import { useEffect } from "react";
import {
  resolveConnectionDeliveryState,
  type ConnectionDeliveryAvailability,
  type ConnectionDeliveryState,
} from "./connectionDeliveryState";

export const useConnectionDeliveryState = ({
  enabled,
  state,
  availability,
  isDirectZone,
  onChange,
}: {
  enabled: boolean;
  state: ConnectionDeliveryState;
  availability: ConnectionDeliveryAvailability | undefined;
  isDirectZone: boolean;
  onChange: (state: ConnectionDeliveryState) => void;
}) => {
  useEffect(() => {
    if (!enabled) return;
    const next = resolveConnectionDeliveryState({
      state,
      availability,
      isDirectZone,
    });
    if (
      next.fulfillmentType !== state.fulfillmentType ||
      next.drayDeliveryMethodVisible !== state.drayDeliveryMethodVisible
    ) {
      onChange(next);
    }
  }, [enabled, state, availability, isDirectZone, onChange]);
};
